import { Component, OnInit } from '@angular/core';
import {LoyaltyService} from '../../../../services/business/loyalty/loyalty.service';
import {ActivatedRoute} from '@angular/router';
import {ResponseLoyaltyDto} from './DTO/response-loyalty.dto';
import {map} from 'rxjs/operators';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import moment from 'moment';

@Component({
  selector: 'app-product-loyalty',
  templateUrl: './product-loyalty.component.html',
  styleUrls: ['./product-loyalty.component.scss']
})
export class ProductLoyaltyComponent implements OnInit {

  constructor(
    private loyaltyService: LoyaltyService,
    private router: ActivatedRoute,
    private notification: NzNotificationService,
  ) { }

  firstScreen = true;
  screenType: string;
  secondScreen = false;
  loyaltyCampaignType = '3';
  checked = true;
  page: number;
  items = [];
  page_size: number;
  selectItems;
  selectedCode = '';
  selectedCodeCustom = '';
  giftCodeCustom = '';
  loyaltyGiftCode = '';
  checkedApprove;
  lastValue;
  barcode: any;
  isShowButton = true;
  listOfLoyalty: ResponseLoyaltyDto;
  options = [
    // { label: 'Chọn chương trình loyalty từ danh sách', value: '1' },
    // { label: 'Nhập mã chương trình loyalty', value: '2' },
    { label: 'Sử dụng chương trình do iCheck tài trợ', value: '3' },
  ];
  productId: string;
  async ngOnInit() {
    this.barcode = localStorage.getItem('barcode');
    this.productId = this.router.snapshot.paramMap.get('id');
    this.loyaltyService.checkRegisLoyalty().pipe(map(z => z.code)).subscribe(code => {
      this.isShowButton = code !== 1;
    });
    await this.selectedItem();
    this.loadAllLoyalty(1 , 6);
    this.loadCampaignAll();
  }

  formatDate(date) {
    return moment(date).format('DD/MM/yyyy');
  }

  getStatus(start, end) {
    const current = moment();
    if (current.isBefore(moment(start))) {
      return 'Chưa bắt đầu';
    }

    if (current.isAfter(moment(end))) {
      return 'Đã kết thúc';
    }

    return 'Đang diễn ra';
  }

  listCampaignAll: any = [];
  loadCampaignAll() {
    // console.log("barcode", barcode)
    this.loyaltyService.campaignAll(this.barcode || '').subscribe(res => {
      // console.log("res", res);
      if (res && res.code === 1) {
        this.listCampaignAll = res.items || [];
        this.campaignCodeSelect = res.items && res.items.length
          ? [...res.items].filter(item => item.campaignAllStatus).length
            ? [...res.items].filter(item => item.campaignAllStatus)[0].code : null : null;
      }
    });
  }

  campaignCodeSelect: any;
  listClick(newValue) {
    if (this.campaignCodeSelect === newValue) {
      this.campaignCodeSelect = '';
    } else {
      this.campaignCodeSelect = newValue;
    }
  }

  submitCampaign() {
    this.loyaltyService.settingCampaignAll({
      barcode: this.barcode,
      used: !!this.campaignCodeSelect
    }).subscribe(res => {
      if (res && res.code === 1) {
        this.notification.create('success', 'Thông báo', 'Cài đặt thành công');
      } else {
        this.notification.create('error', 'Thông báo', res.message);
      }
    });
  }

  async selectedItem() {
    const query = {
      productId: this.productId
    };
    this.selectItems = await this.loyaltyService.getListLoyaltyWithProductId(query).pipe(map(z => {
      // this.loyaltyCampaignType = '3'
      if (z && z.data && z.data.type) {
        this.loyaltyCampaignType = z.data.type.toString();
        this.selectRadioButton(this.loyaltyCampaignType);
        if (this.loyaltyCampaignType === '2') {
          this.selectedCodeCustom = z.data.code;
          this.giftCodeCustom = z.data.giftCode;
          this.secondScreen = true;
          this.firstScreen = false;
        }
        if (this.loyaltyCampaignType === '1') {
          this.selectedCode = z.data.code;
          this.loyaltyGiftCode = z.data.giftCode;
          this.secondScreen = false;
          this.firstScreen = true ;
        }
      }
      if (z && !z.data) {
        return null;
      }
      return z.data.code;
    }))
      .toPromise();
  }

  loadAllLoyalty(page, page_size) {
    const query = {
      page ,
      page_size
    };
    this.loyaltyService.getListLoyalty(query).subscribe(res => {
      console.log("ré", res)
      this.listOfLoyalty = res;
      // list loyalty
      if (this.listOfLoyalty.items && this.listOfLoyalty.items.length > 0) {
        this.items = this.listOfLoyalty.items.map(z => {
          let color = '';
          switch (z.status) {
            case 'Đang Diễn Ra' : color = '#35C759'; break;
            case 'Đã Kết Thúc' : color = '#B4B4B4'; break;
            default:
              color = 'red';
          }
          if (this.selectItems === z.code) {
            return {...z , checked: true , color};
          }
          return {...z , checked: false, color};
        });

        this.page = this.listOfLoyalty.currentPage;
        this.page_size = this.listOfLoyalty.pageSize;
        this.lastValue = this.items.map(z => {
          return {...z};
        });
      }
      console.log('this.lastValue', this.lastValue);
    }, error => console.log(error));
  }
  pageIndexChange(page) {
    this.loadAllLoyalty(page, this.page_size );
  }
  pageSizeChange(pageSize) {
    this.loadAllLoyalty(this.page, pageSize);


  }
  clickSelectedBox(checked, value ) {
    this.selectedCode = value;
    this.items.forEach(z => {
      z.checked = z.code === value ? checked : false;
    });
  }
  submit() {
    const body = {
      loyaltyCampaignType: +this.loyaltyCampaignType,
      loyaltyGiftCode: this.giftCodeCustom,
      loyaltyCampaignObject: this.selectedCodeCustom
    };
    this.items.forEach(z => z.checked = false);
    this.loyaltyService.assignGiftCodeByCampaign(this.productId, body).subscribe(z => {
      const {code , message} = z;
      if (code === 1) {

        this.notification.create(
          'success',
          'Thành công',
          message
        );
      }
    });
  }
  approveSetting() {
    const checkedValue = this.items.every(z => !z.checked );
    const body = {
      loyaltyCampaignType: +this.loyaltyCampaignType,
      loyaltyGiftCode: this.loyaltyGiftCode,
      loyaltyCampaignObject: this.selectedCode
    };
    this.selectedCodeCustom  = '';
    this.giftCodeCustom  = '';
    this.loyaltyService.assignGiftCodeByCampaign(this.productId, body).subscribe( z => {
      const {code , message} = z;
      this.lastValue = this.items.map(z => {
        return {...z};
      });

      if (code === 1) {

        this.notification.create(
          'success',
          'Thành công',
          message
        );
      }

    });
  }
  async selectRadioButton(value) {
    if (this.lastValue ) {
      this.items = this.lastValue.map(z => {
        return {...z};
      });
    }
    this.loyaltyCampaignType = value;
    // if (value === '1') {
    //   this.loyaltyCampaignType = value;
    //   this.firstScreen = true;
    //   this.secondScreen = false;
    //   new ClickTekoDto('portal_product_detail_loyalty', 'choose_loyalty_form_list', 'portal_product_detail_loyalty', {});
    //   return;
    // }
    // new ClickTekoDto('portal_product_detail_loyalty', 'put_loyalty_code', 'portal_product_detail_loyalty', {});
    // this.firstScreen = false;
    // this.secondScreen = true;
  }
}
